import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
   "@global": {
      "@keyframes slideInFromLeft " :{
       " 0%" :{
          transform: "translateX(-100%)"
        },
       " 100%": {
          transform: "translateX(0)"
        }
    
        }
    },
 home:{
    display: "grid",
    // backgroundColor:"#fafafa",
    // borderRadius:"20px",
    gridTemplateColumns: "350px 350px",
    animation: "1s ease-out 0s 1 slideInFromLeft  ",
    padding:"5px",

    justifyContent: "space-evenly",
margin:"0 auto",

   
    gridColumnGap:"100px",
    gridRowGap:"50px",
    [theme.breakpoints.between('xs', 'sm')]: {
        gridTemplateColumns: "330px",
      
      },
      [theme.breakpoints.between('sm','md')]: {
         gridTemplateColumns: "400px",
       
       },
   


   
    alignItems: "center",

 }
 ,
 box:{

    margin:2,

    
    
    },
    welcomeText:{
       color:theme.palette.secondary.main,
       fontWeight:"bold",
    
    }
    
}));
